import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritiesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priorities',
	path: '/jira/settings/issues/priorities',
};
